import React, { useState, useEffect } from 'react';
import FormComponent from '../../../Reusable_Components/FormComponent';
import axios from 'axios';
import { API_ROUTES, API_DOMAIN, headers } from '../../../Reusable_Components/Config/apiConfig';
import { useParams } from 'react-router-dom';

const SegmentationInput = () => {
  const { segmentationId = '' } = useParams();
  const decodedId = segmentationId ? atob(segmentationId) : segmentationId;
  const id = decodedId.replace(/\D/g, '');
  const [isEditing, setIsEditing] = useState(false);
  const [formData, setFormData] = useState({});
  const route = 'segmentation';

  useEffect(() => {
    if (segmentationId) { setIsEditing(true); fetchDetails(); }
  }, [segmentationId]);

  const fetchDetails = async () => {
    try {
      const response = await axios.get(API_DOMAIN + API_ROUTES['segmentation'] + id + '/', { headers });
      setFormData(response.data);
    } catch (error) { console.error('Error fetching Segmentation details:', error); }
  };

  const fields = [
    { name: 'name', label: 'Name', type: 'text', required: true },
    { name: 'description', label: 'Description', type: 'textarea', required: true },
    { name: 'criteria', label: 'Criteria', type: 'textarea', required: true }
  ];

  return (
    <div>
      <h1>{isEditing ? 'Edit Segmentation' : 'Create Segmentation'}</h1>
      <FormComponent fields={fields} initialFormData={formData} route={route} cancelPath="/reporting/segmentation/list" />
    </div>
  );
};

export default SegmentationInput;